import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "@shared/lib/auth";
import { ToastProvider } from "@shared/lib/toast";
import { ThemeProvider } from "@shared/lib/ThemeContext";
import { AppUpdateProvider } from "@shared/lib/useAppUpdate";
import { TextureOverlay } from "@shared/components/TextureOverlay";
import { CenterTransitionOverlay } from "@shared/components/CenterTransitionOverlay";
import { FeedbackButton } from "@shared/components/FeedbackButton";
import { AppUpdatePrompt } from "@shared/components/AppUpdatePrompt";
import { ErrorBoundary } from "@shared/components/ErrorBoundary";
import { App } from "./App";
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ThemeProvider>
      <ToastProvider>
        <AuthProvider>
          <AppUpdateProvider>
            <TextureOverlay />
            <CenterTransitionOverlay />
            <BrowserRouter>
              <ErrorBoundary>
                <App />
              </ErrorBoundary>
            </BrowserRouter>
            <FeedbackButton aboveTabBar />
            <AppUpdatePrompt />
          </AppUpdateProvider>
        </AuthProvider>
      </ToastProvider>
    </ThemeProvider>
  </React.StrictMode>
);
